if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      // Special handling for social links - always keep open and hide arrow
      if (this.id && this.id.includes('social_links')) {
        this.forceSocialLinksOpen();
        return; // Skip normal accordion behavior for social links
      }

      if (FoxTheme.config.mqlTablet) {
        if (!this.openDefault) this.open = false;
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.open = false;
        } else {
          this.open = true;
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open = true;
      });
    }

    forceSocialLinksOpen() {
      // Force the details element to be open
      this.setAttribute('open', '');
      this.setAttribute('aria-expanded', 'true');

      // Force the content to be visible
      const content = this.querySelector('.accordion-details__content');
      if (content) {
        content.style.opacity = '1';
        content.style.transform = 'translateY(0px)';
        content.style.display = 'block';
      }

      // Hide the arrow
      const arrow = this.querySelector('.icon-plus-toggle');
      if (arrow) {
        arrow.style.display = 'none';
      }

      // Disable click functionality on summary
      const summary = this.querySelector('summary');
      if (summary) {
        summary.style.pointerEvents = 'none';
        summary.style.cursor = 'default';
      }

      // Re-enable clicks on social links
      const socialLinks = this.querySelectorAll('.social__link');
      socialLinks.forEach(link => {
        link.style.pointerEvents = 'auto';
      });
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}